<script lang="ts">
  import OperationsManager from '@mtc/operations-manager'
  import Base from '@factry/base'
  import DefectManager from '@factry/defect-manager'
  import EquipmentManager from '@factry/equipment-manager'
  import InstructionManager from '@factry/instruction-manager'
  import MaterialManager from '@factry/material-manager'
  import MessageQueueManager from '@factry/message-queue-manager'
  import OrderManager from '@factry/order-manager'
  import WasteManager from '@factry/waste-manager'
</script>

<Base
  options={[
    OperationsManager, EquipmentManager, MaterialManager, MessageQueueManager, InstructionManager, OrderManager, DefectManager, WasteManager,
  ]}
/>
